/* tslint:disable */
import {
  ProductImages
} from '../index';

declare var Object: any;
export interface ImageGalleryInterface {
  "id"?: number;
  "name"?: number;
  "company_id"?: number;
  "image_ids"?: Array<any>;
  images?: ProductImages[];
}

export class ImageGallery implements ImageGalleryInterface {
  "id": number;
  "name": number;
  "company_id": number;
  "image_ids": Array<any>;
  images: ProductImages[];
  constructor(data?: ImageGalleryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ImageGallery`.
   */
  public static getModelName() {
    return "ImageGallery";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ImageGallery for dynamic purposes.
  **/
  public static factory(data: ImageGalleryInterface): ImageGallery{
    return new ImageGallery(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ImageGallery',
      plural: 'ImageGalleries',
      path: 'ImageGalleries',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'number'
        },
        "company_id": {
          name: 'company_id',
          type: 'number'
        },
        "image_ids": {
          name: 'image_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
      },
      relations: {
        images: {
          name: 'images',
          type: 'ProductImages[]',
          model: 'ProductImages',
          relationType: 'referencesMany',
                  keyFrom: 'image_ids',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ImageGallery.ts